module.exports = __webpack_public_path__ + "static/media/svg--logo-text.eb2b4cd2.svg";